/**
 * Persists the optional marketing consent collected during registration. It
 * runs once the session exists, so it reuses the panel's consents route.
 *
 * A failure here must not undo an account that was just created, so it is
 * reported to the console rather than surfaced as a blocking error — the user
 * can still flip the consent in the client panel.
 */
export const saveMarketingConsent = async (marketing: boolean) => {
  try {
    const response = await fetch("/api/panel/consents", {
      method: "PUT",
      body: JSON.stringify({ marketing }),
    });

    if (!response.ok) {
      throw new Error(`Consents update failed with ${response.status}`);
    }
  } catch (error) {
    console.error(
      "Saving the marketing consent after registration failed",
      error,
    );
  }
};
